import { FormControlLabel, Stack, Switch, TextField } from '@mui/material'
import type { FormikProps } from 'formik'
import { type ChangeEvent, type FC, useId } from 'react'
import FormikErrorMessage from 'src/components/formikErrorMessage/FormikErrorMessage'
import type { NumberRuleProps } from './EditResponseNumberRuleEnableProductMasterDrawer'

// NOTE: この 50 という上限はシステム保護のために後から設定されたものであり、
// 既存のデータで 50 より大きい有効な値がないことを確認できたため 50 としています。
export const MAX_NUMBER_FRACTIONAL_DIGITS = 50

const FractionalDigitsRow: FC<{
  formikProps: FormikProps<NumberRuleProps>
}> = ({
  formikProps: {
    values: { decimalPoint },
    setFieldValue,
    errors,
  },
}) => {
  const onToggle = (_: ChangeEvent<HTMLInputElement>, checked: boolean) =>
    setFieldValue('decimalPoint.isActive', checked ? 1 : 0)

  const onChangeDigits = (e: ChangeEvent<HTMLInputElement>) =>
    setFieldValue(
      'decimalPoint.value',
      e.target.value === '' ? undefined : Number(e.target.value),
    )

  const decimalPointInputId = useId()

  return (
    <Stack>
      <FormControlLabel
        control={
          <Switch checked={!!decimalPoint?.isActive} onChange={onToggle} />
        }
        label="小数点以下の桁数を設定する"
        sx={{ mb: 1 }}
      />
      <Stack direction="row" alignItems="center" sx={{ mb: 1 }} spacing={1}>
        <TextField
          id={decimalPointInputId}
          type="number"
          size="small"
          name="decimalPoint"
          placeholder="1"
          slotProps={{ htmlInput: { min: 0 } }}
          value={decimalPoint?.value ?? ''}
          onChange={onChangeDigits}
          disabled={!decimalPoint?.isActive}
          sx={{ width: 60 }}
        />
        <label htmlFor={decimalPointInputId}>桁</label>
      </Stack>
      <FormikErrorMessage name="decimalPoint" errors={errors} />
    </Stack>
  )
}

export default FractionalDigitsRow
